import { pxToRem } from './pxToRem';

/** @deprecated Just set values directly */
export var inset = function inset(x) {
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
  return "".concat(pxToRem(y), " ").concat(pxToRem(x), " ").concat(pxToRem(y), " ").concat(pxToRem(x));
};

/** @deprecated Just set values directly */
export var stack = function stack(value) {
  return "0 0 ".concat(pxToRem(value), " 0");
};